import { Services } from "@ca.vmedia.tv/services";
import { defineNuxtPlugin } from '#app'

declare module '#app' {
    interface NuxtApp {
        $services: Services;
    }
}
declare module 'vue' {
    interface ComponentCustomProperties {
        $services: Services;
    }
}

export default defineNuxtPlugin((nuxtApp) => {
    const { $domains } = useNuxtApp();

    const services = new Services(
        $domains,
    );

    nuxtApp.provide('services', services);
});
